export default __webpack_public_path__ + "static/media/i1.62415bbd.svg";